import { DatePickerV2 } from '@profgeosoft-ui/react';
import { useTranslation } from 'react-i18next';

import { wrap } from 'src/packages/mobx-di/wrap';

import type { MutableRefObject } from 'react';
import type { TDateOnlyPickerView, TFieldRulesData } from 'src/services/directory-service/types';

type Props = {
  fieldView: TDateOnlyPickerView;
  value: number | null;
  error?: string;
  fieldRulesData?: TFieldRulesData;
  className?: string;
  innerRef?: MutableRefObject<HTMLInputElement | null>;
  onChange(fieldId: string, value: unknown): void;
  onBlur?(fieldId: string): void;
};

export const DateOnlyPickerComponent = wrap<Props>(function DateOnlyPickerComponent({
  fieldView,
  innerRef,
  className,
  value,
  error,
  fieldRulesData,
  onChange,
  onBlur,
}) {
  const { t } = useTranslation();

  const handleChange = (date: number | null) => {
    onChange(fieldView.fieldId, date);
  };

  const handleBlur = () => {
    onBlur?.(fieldView.fieldId);
  };

  return (
    <DatePickerV2
      ref={innerRef}
      className={className}
      value={value}
      loading={fieldRulesData?.isLoading}
      status={error ? 'error' : undefined}
      placeholder={t('common:placeholders.chooseDate')}
      disabled={fieldRulesData?.isDisabled || fieldRulesData?.isEnteringBlocked}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
});
